import AWS from "aws-sdk";
import _ from "lodash";

export function deleteObject(bucketName, key) {
	return new Promise((resolve, reject) => {
		// console.log("Attempting to delete", bucketName, key);
		const bucket = new AWS.S3({ useDualStack: true, params: { Bucket: bucketName } });
		bucket.deleteObject({ Key: key }, err => {
			if (err) {
				reject(err);
			} else {
				resolve();
			}
		});
	});

}
export function deleteObjects(bucketName, objects) {
	return new Promise((resolve, reject) => {
		const bucket = new AWS.S3({ useDualStack: true, params: { Bucket: bucketName } });
		bucket.deleteObjects({ Delete: { Objects: objects } }, err => {
			if (err) {
				reject(err);
			} else {
				resolve();
			}
		});
	});

}

export function uploadObject(bucketName, path, content, contentType) {
	return new Promise((resolve, reject) => {
		// Instantiate aws sdk service objects now that the credentials have been updated.
		const _bucket = new AWS.S3({ useDualStack: true, params: { Bucket: bucketName } });

		const params = { Key: path };
		if (contentType) {
			params.ContentType = contentType;
		} else {
			let extn = path.split(".").pop();
			let contentType = "application/octet-stream";
			switch (extn) {
				case "html": {
					contentType = "text/html";
					break;
				}
				case "css": {
					contentType = "text/css";
					break;
				}
				case "js": {
					contentType = "application/javascript";
					break;
				}
				case "pdf": {
					contentType = "application/pdf";
					break;
				}
				case "png":
				case "jpg":
				case "jpeg":
				case "gif":
				case "webm": {
					contentType = "image/" + extn;
					break;
				}
				default: {
					console.log("Unknown extension", extn);
					}
			}
			params.ContentType = contentType;
		}
		params.Body = content;

		_bucket.upload(params, (err) => {
			if (err) {
				reject(err);
			} else {
				resolve();
			}
		});
	});
}


export function copyObject(sourceBucket, sourceKey, destinationBucket, destinationKey) {
	return new Promise((resolve, reject) => {
		let params = {
			CopySource: `/${sourceBucket}/${sourceKey}`,
			Key: destinationKey,
			ServerSideEncryption: "AES256"
		};
		const bucket = new AWS.S3({ useDualStack: true, params: { Bucket: destinationBucket } });
		bucket.copyObject(params, function (err, data) {
			if (err) {
				reject(err);
			} else {
				resolve(data);
			}
		});
	});
}

export function moveObject(sourceBucket, sourceKey, destinationBucket, destinationKey) {
	return new Promise((resolve, reject) => {
		copyObject(sourceBucket, sourceKey, destinationBucket, destinationKey).then(() => {
			deleteObject(sourceBucket, sourceKey).then(() => {
				resolve();
			}).catch(err => {
				reject(err);
			});
		}).catch(err => {
			reject(err);
		});
	});
}


export function objectExists(bucketName, key) {
	return new Promise((resolve, reject) => {

		const bucket = new AWS.S3({ useDualStack: true, params: { Bucket: bucketName } });
		bucket.headObject({ Key: key }, function (err) {
			if (err && err.code === "NotFound") {
				resolve(false);
			} else if (err) {
				reject(err);
			} else {
				resolve(true);
			}
		});

	});
}

export function listAllObjects(bucketName, prefix) {
	return new Promise((resolve, reject) => {
		let prefixes = prefix;
		if (!_.isArray(prefix)) {
			prefixes = [prefix];
		}
		const promises = [];
		prefixes.forEach(prefix => {
			promises.push(new Promise((res, rej) => {
				recursiveListObjects(bucketName, prefix, (err, data) => {
					if (err) {
						rej(err);
					} else {
						res(data);
					}
				});
			}));
		});

		Promise.all(promises).then(results => {
			// console.log("Got results", results);
			let result = [];
			results.forEach(res => {
				result = _.concat(result, res);
			});
			resolve(result);
		}).catch(err => {
			reject(err);
		});
	});
}

function recursiveListObjects(bucketName, prefix = null, cb = () => { }, marker = null, files = []) {
	const bucket = new AWS.S3({ useDualStack: true, params: { Bucket: bucketName } });
	const params = {
		Bucket: bucketName
	};

	// are we paging from a specific point?
	if (marker) {
		params.Marker = marker;
	}

	if (prefix) {
		params.Prefix = prefix;
	}

	bucket.listObjects(params, (err, data) => {
		if (err) {
			return cb(err);
		}

		// concat the list of files into our collection
		files = files.concat(data.Contents);

		// are we paging?
		if (data.IsTruncated) {
			let length = data.Contents.length;
			let marker = data.Contents[length - 1].Key;
			// recursion!
			recursiveListObjects(bucketName, prefix, cb, marker, files);
		} else {
			cb(undefined, files);
		}

	});
}

export function getObjectContent(bucketName, key, attemptParse = true) {
	return new Promise((resolve, reject) => {
		// console.log("Attempting to get object content", bucketName, key);
		const bucket = new AWS.S3({ useDualStack: true, params: { Bucket: bucketName, ResponseCacheControl: "no-cache" } });
		bucket.getObject({ Key: key }, (err, data) => {
			if (err) {
				reject(err);
			} else {
				let result = data.Body;
				if (attemptParse) {
					try {
						result = JSON.parse(result);
					} catch (err) {
						console.warn(err);
					}
				}
				// console.log("Got activity content", result);
				resolve(result);
			}
		});
	});
}